// app/javascript/controllers/validation_rules.js

export const rules = {
  // Named rule sets for common validations
  givableAmount: {
    required: true,
    minAmount: 1,
    maxAmount: 15000,
    pattern: "^\\d+(\\.\\d{0,2})?$",
    message: (_value, { min, max }) => {
      return (
      `Amount must be between $${min} and $${max}`
      )
    }
  },

  email: {
    required: true,
    email: true,
    maxLength: 255
  },

  cardNumber: {
    required: true,
    pattern: "^[0-9]{16}$",
    validator: (value) => {
      // Luhn algorithm check
      const sum = value
        .split("")
        .reverse()
        .map(Number)
        .map((n, i) => i % 2 ? n * 2 : n)
        .map(n => n > 9 ? n - 9 : n)
        .reduce((acc, n) => acc + n)
      
      return sum % 10 === 0 ? null : "Invalid card number"
    }
  },

  phone: {
    pattern: "^\\+?[1-9]\\d{1,14}$",
    message: "Please enter a valid phone number"
  }
}

// Custom validators can be added here
export const validators = {
  password: (value, { minLength = 8, requireSpecial = true } = {}) => {
    const errors = []
    if (value.length < minLength) {
      errors.push(`Must be at least ${minLength} characters`)
    }
    if (requireSpecial && !/[!@#$%^&*]/.test(value)) {
      errors.push("Must contain a special character")
    }
    return errors.length ? errors.join(", ") : null
  }
}
